import React from "react";
import Chatbot from "./ChatbotAi";

function App() {
    return (
        <div>
            <h2 style={{ textAlign: "center"}}>Master English Language</h2>
            <Chatbot />
        </div>
    );
}

export default App;

